<template>
  <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules">
    <div class="input_wrapper">
      <label :for="name">{{ label }}</label>

      <multiselect
        :value="value"
        :options="statics"
        label="title"
        track-by="id"
        :searchable="true"
        :allow-empty="true"
        :show-labels="false"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        @input="updateValue"
      ></multiselect>
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: false,
      default: "",
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      default: " ",
    },

    apiUrl: {
      required: false,
      default: " ",
    },
  },
  data() {
    return {
      selectedValue: null,
      loading: false,
      statics: [],
    };
  },
  mounted() {
    this.getStatics();
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e);
    },
    getStatics() {
      if (this.statics.length) return;
      this.loading = true;

      this.axios({
        method: "GET",
        url: this.apiUrl,
      })
        .then((res) => {
          this.statics = res.data.data;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
  },
};
</script>

<style></style>
